import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import {BranchModel} from "../models/branch.model";

export class BranchesAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

// ******************************
//        Public methods
// ******************************

// CREATE //
  createSuccess() {
    const message = {
      body: 'BRANCH_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'BRANCH_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

// UPDATE //
  updateSuccess() {
    const message = {
      body: 'BRANCH_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'BRANCH_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

// UPDATE MANY //
  updateManySuccess() {
    const message = {
      body: 'BRANCH_UPDATE_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateManyError() {
    const message = {
      body: 'BRANCH_UPDATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

// REMOVE //
  removeSuccess(branch: BranchModel) {
    const message = {
      body: 'X_BRANCH_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message, branch)
  }

  removeError() {
    const message = {
      body: 'BRANCH_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

// DELETE //
  deleteOneSuccess(branch: BranchModel) {
    const message = {
      body: 'X_BRANCH_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, branch)
  }

  deleteOneError() {
    const message = {
      body: 'BRANCH_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  editBranchesTagsSuccess() {
    const message = {
      body: 'BRANCHES_TAGS_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editBranchesTagsError() {
    const message = {
      body: 'BRANCHES_TAGS_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.branches')
  .service('branchesAlerts', BranchesAlerts);
